import React, { MouseEventHandler } from 'react';
import { Button, Modal } from '@mui/material';
import {
  ButtonWrapperStyled,
  ContentStyled,
  PolicySubtitle,
  PolicyTitle,
  WrapperStyled
} from './styles';

export interface ITermsOfUseModal {
  open: boolean;
  closeModal: MouseEventHandler<HTMLButtonElement>;
}

/**
 * @param {ITermsOfUseModal} props
 * @returns TermsOfUseModal component
 */
export default function TermsOfUseModal(props: ITermsOfUseModal): React.JSX.Element {
  return (
    <Modal open={props.open} onClose={props.closeModal}>
      <WrapperStyled>
        <PolicyTitle>Política de privacidade</PolicyTitle>

        <ContentStyled>
          <PolicySubtitle>
            1. PROPÓSITO DA POLÍTICA DE PRIVACIDADE
          </PolicySubtitle>
          <p>
            1.1. A Consorciei Participações S.A., CNPJ 31.701.391/0001-03, com
            sede à Av. Brigadeiro Faria Lima, 1461, 4º andar, Jardim Paulistano,
            São Paulo-SP, CEP 01451-002 (referida como “Consorciei” ou por meio
            de derivações como “nós” ou “nosso”) é uma empresa que possui o
            compromisso com a transparência, a privacidade e a segurança de
            dados de seus colaboradores, clientes e parceiros comerciais.
          </p>
          <p>
            1.2. A presente Política de Privacidade possui como objetivos:
            Estabelecer diretrizes para proteger e salvaguardar os Dados
            Pessoais durante toda a prestação de Serviços (como, por exemplo, ao
            longo do processo de cadastro, interações para solução de dúvidas e
            realização do seu tratamento); Nortear a definição de normas e
            procedimentos específicos de segurança; Informar a finalidade da
            coleta de dados, o mapeamento dos dados, o compartilhamento com
            terceiros, o tempo de processamento, o canal oficial de comunicação,
            a base legal de tratamento, as partes envolvidas e o país que
            receberá / enviará os dados; eImplementar controles e procedimentos
            para reduzir a vulnerabilidade a incidentes, em conformidade com a
            legislação de privacidade, incluindo a Lei 13.709/2018 (Lei Geral de
            Proteção de Dados - “LGPD”).
          </p>
          <PolicySubtitle>2. CONTEXTO, REGRAS E PROCEDIMENTOS</PolicySubtitle>
          <p>
            2.1. Para que a Política de Privacidade seja bem compreendida, é
            fundamental esclarecer algumas regras e procedimentos, bem como
            explicar a dinâmica empresarial da Consorciei.
          </p>
          <p>
            2.2. A Consorciei é uma empresa que atua no mercado secundário de
            consórcios, por meio de (a) compra de cotas de grupos de consórcio
            administrados por administradoras de consórcio; e (b) prestação de
            serviços de (i) intermediação de compra e venda de cotas de
            consórcio, (ii) de cessão de direito de uso de programas de
            computador (software) desenvolvidos pela empresa (“Plataforma
            Consorciei”); e (iii) de cobranças e de consultoria especializada a
            fundos de investimentos em direitos creditórios (“Serviços“).
          </p>
          <p>
            2.3. A Consorciei estabelece os seguintes pilares:
            Confidencialidade: garantir que a informação só estará disponível
            para pessoas autorizadas.Integridade: garantir que a informação,
            processada, armazenada ou transmitida, não sofrerá qualquer
            modificação não autorizada, seja intencional ou não.Disponibilidade:
            garantir que a informação estará disponível sempre que for
            necessário.
          </p>
          <p>
            2.4. Para desenvolver os processos da Consorciei, são considerados
            os seguintes princípios: Autenticidade: garantir que a informação é
            original e que não foi alvo de alteração.Irretratabilidade ou não
            repúdio: garantir que o legítimo autor da informação não possa negar
            a sua autoria.Conformidade: garantir que os processos estejam de
            acordo com os regulamentos e leis vigentes aplicáveis, de forma a
            seguir todos os protocolos exigidos no setor de atuação.
          </p>
          <p>
            2.5. A Política de Privacidade é aplicável para toda e qualquer
            interação que a Consorciei possa ter com Você, como o portal de
            usuários em geral nosso site (“Site”), troca de e-mails entre Você e
            a Consorciei para contato (“Email”), contato telefônico inclusive
            por meio de WhatsApp (“Telefone”), por meio do Facebook
            (“Facebook”), do Instagram (“Instagram”) e da Plataforma Consorciei,
            todos para consulta de informações e para esclarecimento de dúvidas
            pontuais sobre os Serviços e para viabilizar a prestação dos nossos
            Serviços.
          </p>
          <p>
            2.6. Nossos Site, E-mail, Telefone, Facebook, Instagram, Aplicativo
            e Plataforma Consorciei são em sua maioria integrados entre si e,
            portanto, aqui referidos conjuntamente como “Plataformas”.
          </p>
          <p>
            2.7. Para todas as etapas da prestação dos Serviços, nossos
            colaboradores e Parceiros utilizam a Plataforma Consorciei,
            incluindo para propostas comerciais, cadastro de clientes e
            parceiros, atendimento a dúvidas, do início ao fim, aquisição e
            transferência de cotas de grupos de consórcio.
          </p>
          <p>
            2.8. Esta Política diz respeito ao tratamento de Dados Pessoais
            realizado pela Consorciei, mas o seu uso de plataformas de terceiros
            para nos contatar (como WhatsApp, Facebook ou Instagram) estará
            sujeito também às políticas de privacidade e termos de uso de tais
            terceiros. Recomendamos que você consulte tais documentos antes de
            usar tais canais de comunicação.
          </p>
          <PolicySubtitle>3. DEFINIÇÕES</PolicySubtitle>
          <p>
            3.1. Cliente - toda pessoa física ou jurídica que utiliza de site,
            aplicativo ou de que alguma forma usufrui da Plataforma Consorciei.
          </p>
          <p>
            3.2. Dados pessoais - qualquer informação relacionada a uma pessoa
            que a identifique ou que, usada em combinação com outras informações
            tratadas, identifique um indivíduo. Ainda, qualquer informação por
            meio da qual seja possível identificar uma pessoa ou com ela entrar
            em contato.
          </p>
          <p>
            3.3. Tratamento de dados pessoais - considera-se tratamento de dado
            pessoal a coleta, produção, recepção, classificação, utilização,
            acesso, reprodução, transmissão, distribuição, processamento,
            arquivamento, armazenamento, eliminação, avaliação ou controle da
            informação, comunicação, transferência, difusão ou extração de dados
            de pessoas físicas.
          </p>
          <p>
            3.4. Titular de dados - qualquer pessoa física que tenha seus dados
            pessoais tratados pela Consorciei.
          </p>
          <p>
            3.5. Necessidade - o tratamento de dados pessoais será limitado ao
            mínimo necessário para o propósito almejado. Ou seja, deve ser
            pertinente, proporcional e não excessivo.
          </p>
          <p>
            3.6. Consentimento - autorização livre, informada e inequívoca que o
            titular dá para tratamento de seus dados pessoais com finalidade
            previamente estipulada. Após dar o consentimento, você pode
            revogá-lo a qualquer momento. Contudo, a revogação não cancela o
            tratamento realizado previamente.
          </p>
          <PolicySubtitle>
            4. QUAIS DADOS PESSOAIS SÃO COLETADOS PELA CONSORCIEI QUANDO VOCÊ
            UTILIZA A NOSSA PLATAFORMA
          </PolicySubtitle>
          <p>
            4.1. A quantidade e o tipo de informações coletadas pela Consorciei
            variam conforme o uso que você faz da nossa Plataforma. Para tornar
            mais acessíveis essas definições e diferenças, segmentamos abaixo os
            dados que podemos coletar sobre você:
          </p>

          <table>
            <tr>
              <th>Grupo de dados</th>
              <th>Como são coletados</th>
              <th>Quais dados são coletados e tratados</th>
            </tr>
            <tr>
              <td>Dados que coletamos automaticamente</td>
              <td>Coletados automaticamente quando visitam nosso site</td>
              <td>
                <li>Endereço IP</li>
                <li>Informações do seu navegador</li>
                <li>Comportamento dentro do site</li>
                <li>Localização geográfica</li>
                <li>Informações do seu sistema operacional</li>
              </td>
            </tr>
            <tr>
              <td>Dados de contato</td>
              <td>
                São fornecidos pelos visitantes por meio do preenchimento de
                formulários ou contato direto com a nossa equipe de atendimento
              </td>
              <td>
                <li>Nome Completo</li>
                <li>E-mail</li>
                <li>Telefone</li>
              </td>
            </tr>
            <tr>
              <td>Dados para acesso aos Serviços</td>
              <td>Ao realizar o cadastro para acessar nossos Serviços</td>
              <td>
                <li>Dados de contato</li>
                <li>Idade</li>
                <li>CPF</li>
                <li>Fotos</li>
                <li>RG</li>
                <li>Profissão</li>
                <li>Estado civil</li>
                <li>Endereço</li>
                <li>CEP</li>
              </td>
            </tr>
            <tr>
              <td>
                Dados importados de outras plataformas, que coletam cookies e
                pixels
              </td>
              <td>Coleta automática de dados realizada por outras empresas.</td>
              <td>Para saber mais, acesse nossa Política de Cookies</td>
            </tr>
            <tr>
              <td>
                Dados que você fornece nas mídias sociais (Facebook e Instagram)
              </td>
              <td>
                São fornecidos por você quando utilizar as mídias sociais da
                Consorciei
              </td>
              <td>
                Informações que podem estar disponíveis no seu perfil, conforme
                você as disponibilize, como:
                <br /> <br />
                <li>Nome Completo</li>
                <li>Idade</li>
                <li>Endereço</li>
                <li>Telefone</li>
                <li>E-mail</li>
                <li>Curtidas</li>
              </td>
            </tr>
            <tr>
              <td>Dados de clientes Consorciei</td>
              <td>
                São fornecidos por você ao contratar os Serviços da Consorciei e
                durante todo o processo
              </td>
              <td>
                <li>Profissão</li>
                <li>Data de nascimento</li>
                <li>Gênero</li>
              </td>
            </tr>
            <tr>
              <td>
                Dados profissionais que a Consorciei recebe por meio de
                parceiros
              </td>
              <td>
                A Consorciei utiliza plataformas de parceiros para encontrar
                candidatos
              </td>
              <td>
                Caso tenha interesse, consulte a Política de Privacidade de
                nossos parceiros
              </td>
            </tr>
            <tr>
              <td>Dados para pagamento</td>
              <td>
                Você fornece os dados à Consorciei e/ou seus parceiros que
                viabilizam o pagamento de valores a vocês para a compra de sua
                cota de grupo de consórcio
              </td>
              <td>
                A depender da forma de pagamento e do parceiro responsável pelo
                meio de pagamento:
                <br /> <br />
                <li>Dados relacionados à conta bancária</li>
              </td>
            </tr>
            <tr>
              <td>Dados de segurança</td>
              <td>
                A Consorciei ou os seus parceiros prestadores de Serviços podem
                coletar esses dados quando o cliente acessa os serviços
              </td>
              <td>
                A depender do parceiro, diferentes dados podem ser tratados.
                Eles podem incluir:
                <br /> <br />
                <li>Imagem do Cliente</li>
                <li>Imagem dos documentos pessoais do cliente</li>
                <li>Imagem do comprovante de residência do cliente</li>
                <li>Nome</li>
                <li>CPF</li>
                <li>Email</li>
                <li>Telefone</li>
              </td>
            </tr>
            <tr>
              <td>Dados de análise de risco</td>
              <td>
                A Consorciei ou os seus parceiros prestadores de Serviços podem
                coletar esses dados quando o cliente manifesta interesse em
                prosseguir com as negociações
              </td>
              <td>
                A depender do parceiro, diferentes dados podem ser enriquecidos
                para que a transação possa ser efetivada:
                <br /> <br />
                <li>Situação cadastral</li>
                <li>Validação de Pessoa Politicamente Exposta</li>
                <li>
                  Verificação de Processos nos Tribunais de Justiça como Réu
                </li>
                <li>Mandados de Prisão com Homônimos</li>
                <li>Antecedentes Criminais</li>
              </td>
            </tr>
          </table>

          <p>
            4.2. Responsabilidade pela coleta de dados de menores: As nossas
            Plataformas não são destinadas a menores de idade. Dessa forma, como
            regra, não coletamos Dados Pessoais de menores de 18 anos, a menos
            que esta coleta se dê por meio dos pais e/ou do responsável legal.
            Não podemos impedir que um menor acesse nossas Plataformas. Porém,
            não coletamos informação pessoal sem deixar claro que a pessoa que
            fornece a informação deve ter pelo menos 18 anos ou estar
            representada por um responsável.
          </p>
          <p>
            4.2.1. Se você é pai, mãe ou responsável legal e sabe que seus
            filhos nos forneceram Dados Pessoais, por favor entre em contato
            conosco. Se ficarmos cientes de que coletamos Dados Pessoais de
            menores de idade sem a verificação do consentimento dos pais ou
            responsáveis legais, tomamos, na máxima extensão possível, medidas
            para remover essas informações de nossos servidores.
          </p>
          <p>
            4.22. Se você fornecer Dados Pessoais de um menor de idade (por
            exemplo, para viabilizar o tratamento desse menor), vamos presumir
            que você é um dos pais ou responsável legal daquele menor, e/ou que
            possui todas as autorizações e poderes necessários para consentir
            com o tratamento de dados do menor.
          </p>
          <p>4.2. Dados coletados de outras fontes:</p>
          <p>
            4.2.1. Dados coletados para efeitos de prevenção de fraudes e
            cumprimento de regimes de informações (listas PEPs, OFAC etc.).
          </p>
          <p>
            4.2.2. Dados de crédito que obtemos de bancos de dados ou centrais
            de risco de crédito e/ou de fontes acessíveis ao público, de acordo
            com a legislação aplicável.
          </p>
          <p>
            4.2.3. Dados que servem para validar a sua identidade, corrigir e/ou
            completar suas informações. Eles são obtidos de fontes seguras e
            confiáveis: órgãos públicos, prestadores de serviços ou parceiros de
            negócios com os quais trabalhamos. Em alguns casos, esses dados
            podem ser considerados sensíveis de acordo com a legislação
            aplicável. Nesses casos, solicitamos seu consentimento expresso para
            processá-los.
          </p>
          <PolicySubtitle>
            5. COMO A CONSORCIEI TRATA E ARMAZENA OS SEUS DADOS PESSOAIS?
          </PolicySubtitle>
          <p>
            5.1. Utilizaremos os Dados Pessoais coletados para as seguintes
            finalidades, de acordo com a base legal aplicável:
          </p>

          <table>
            <tr>
              <th>Finalidade</th>
              <th>Detalhamento</th>
              <th>Grupo de Dados</th>
              <th>Base Legal</th>
            </tr>
            <tr>
              <td>Seleção e recrutamento</td>
              <td>Seleção de candidatos às vagas da Consorciei</td>
              <td>
                Dados profissionais que a Consorciei recebe por meio de
                parceiros
              </td>
              <td>
                Legítimo Interesse (dados comuns) e Consentimento (para dados
                sensíveis)
              </td>
            </tr>
            <tr>
              <td>Marketing e recomendações personalizadas</td>
              <td>
                Atividades de marketing com geolocalização, bem como indicação
                de parceiros e prestadores de Serviços da Consorciei
              </td>
              <td>Endereço</td>
              <td>Legítimo interesse</td>
            </tr>
            <tr>
              <td>
                Prestar os Serviços da Consorciei e viabilizar o seu tratamento
              </td>
              <td>
                Prestar os Serviços a você, incluindo acesso à Plataforma,
                pagamentos, comunicações sobre os Serviços e para orientação
                sobre o tratamento, compartilhamento com parceiros da Consorciei
                que atuam nos Serviços, entre outros
              </td>
              <td>
                Dados para acesso aos Serviços, Dados de clientes Consorciei,
                Dados para pagamento
              </td>
              <td>
                Execução de contrato e Exercício regular de direito em contrato
              </td>
            </tr>
            <tr>
              <td>Comunicações comerciais sobre nossos Serviços</td>
              <td>
                Enviar a você comunicações comerciais como e-mails e outros
                tipos de mensagens e contatos para lhe contar sobre nossos
                Serviços e produtos com base nas suas preferências pessoais
              </td>
              <td>Dados para acesso aos Serviços</td>
              <td>Legítimo interesse</td>
            </tr>
            <tr>
              <td>Avaliação de performance da nossa Plataforma</td>
              <td>
                Disponibilizar marketing personalizado e nos ajudar a verificar
                a qualidade da navegação em nossa Plataforma
              </td>
              <td>Dados que coletamos automaticamente</td>
              <td>Legítimo Interesse</td>
            </tr>
            <tr>
              <td>Emissão de Nota Fiscal</td>
              <td>
                Emissão de nota fiscal pelos Serviços prestados pela Consorciei
              </td>
              <td>Dados para acesso aos Serviços</td>
              <td>Cumprimento de Obrigação Legal</td>
            </tr>
            <tr>
              <td>Controle de acesso</td>
              <td>
                Segurança no acesso à plataforma para realização de transações
                de vendas de cotas de consorcio
              </td>
              <td>Dados de segurança</td>
              <td>Legítimo Interesse</td>
            </tr>
            <tr>
              <td>Cobranças</td>
              <td>
                Realização de cobranças e gestão de inadimplência, o que pode
                incluir contatos com o cliente em questão, protesto de títulos,
                inscrição em cadastro de devedores, entre outros
              </td>
              <td>Dados para acesso aos Serviços</td>
              <td>Exercício regular de direito</td>
            </tr>
            <tr>
              <td>Defesa de direitos e interesses da Consorciei</td>
              <td>
                A Consorciei pode usar os dados pessoais tratados para defender
                seus próprios direitos e interesses garantidos por lei ou por
                contrato
              </td>
              <td>Todos, conforme necessário</td>
              <td>Exercício regular de direito</td>
            </tr>
            <tr>
              <td>Cumprir com obrigações legais</td>
              <td>
                A Consorciei poderá utilizar dados pessoais para cumprir com
                obrigações legais diversas que exijam o tratamento ou
                compartilhamento de dados pessoais com órgãos públicos (como
                obrigações tributárias e aquelas relacionadas à regulamentação
                sanitária e profissional)
              </td>
              <td>Todos, conforme necessário</td>
              <td>Cumprimento de obrigação legal</td>
            </tr>
          </table>

          <p>
            5.2. A Consorciei armazena os dados de seus clientes e parceiros no
            sistema Amazon AWS, com sede nos Estados Unidos, sistema que está em
            conformidade com a Lei Geral de Proteção de Dados Brasileira. Além
            disso, a AWS implementa e mantém medidas de segurança técnica e
            organizacional aplicáveis a serviços de infraestrutura da Nuvem AWS
            em estruturas e certificações de garantia de segurança reconhecidas
            mundialmente, incluindo ISO/IEC 27001, ISO/IEC 27017, ISO/IEC 27018,
            PCI DSS Level 1 e SOC 1, 2 e 3.
          </p>
          <PolicySubtitle>
            6. COM QUEM A CONSORCIEI COMPARTILHA OS SEUS DADOS?
          </PolicySubtitle>
          <p>
            6.1. A Consorciei opera com um conjunto de colaboradores para
            oferecer a você nossos Serviços. Em todo e qualquer tratamento de
            Dados Pessoais que realizamos, resguardamos ao máximo sua
            privacidade e a proteção de seus Dados Pessoais. Dessa forma,
            podemos transferir seus Dados Pessoais para terceiros nos seguintes
            casos:
          </p>
          <p>
            6.1.1. Prestação dos Serviços: Utilizamos profissionais parceiros
            para nos ajudar a prestar os Serviços e precisamos compartilhar seus
            Dados Pessoais com eles. Vale lembrar que prestamos nossos Serviços
            por meio de nossa plataforma e por meio de Parceiros. O uso dos seus
            Dados Pessoais pelos Parceiros está limitado à finalidade de
            execução de parte dos Serviços.
          </p>
          <p>
            6.1.2. Novos Negócios: Podemos transferir seus Dados Pessoais em
            processos de aquisição, venda, fusão, reorganização societária ou
            qualquer outra mudança de controle da Consorciei. Nesses casos, nós
            garantiremos a que a pessoa, física ou jurídica, que venha a acessar
            ou assumir o controle sobre os dados tratados nos termos desta
            Política também sejam vinculados a ela, garantindo a continuidade da
            proteção dos Dados Pessoais, e comunicando vocês, com antecedência,
            caso essa Política seja alterada.
          </p>
          <p>
            6.1.3. Requisição Judicial ou Administrativa: Podemos compartilhar
            Dados Pessoais em caso de requisição judicial ou administrativa por
            autoridades competentes ou em cumprimento de dever legal.
          </p>
          <p>
            6.1.4. Parceiros de Analytics: Os dados que armazenamos dos Usuários
            de nossas Plataformas, podem vir a ser utilizados para fins de
            estatísticas (analytics), com a finalidade de a Consorciei
            compreender quem são as pessoas que visitam nossa Plataforma, que
            são interessados ou de fato contratantes de nossos Serviços. Tais
            dados passam por pseudonimização e não buscam identificar ou tornar
            identificável os titulares dos dados pessoais, mas tão somente
            compreender melhor como se dá o acesso na Plataforma, a fim de
            melhorar a prestação dos Serviços e de customizá-los.
          </p>
          <p>
            6.1.5. Cumprimento de obrigações legais ou exercício regular de
            direito: Podemos usar seus Dados Pessoais para resguardar e proteger
            direitos da Consorciei na medida em que eles sejam necessários para
            cumprir a legislação aplicável; fazer cumprir ou aplicar nossos
            Termos de Uso e outros acordos a que estejamos sujeitos; ou proteger
            os direitos, propriedade ou segurança da Consorciei, dos nossos
            funcionários, dos usuários da nossa Plataforma e dos nossos
            Parceiros.
          </p>
          <p>
            6.1.6. Com a sua autorização: Em outras situações nas quais haja a
            necessidade de compartilhamento dos seus Dados Pessoais, enviaremos
            uma notificação para você solicitando sua aprovação.
          </p>
          <p>
            6.2. Sempre que possível, buscamos compartilhar seus Dados Pessoais
            de forma anônima, visando preservar ao máximo a sua privacidade.
            Além disso, nós não alugamos ou vendemos seus Dados Pessoais para
            ninguém.
          </p>
          <PolicySubtitle>
            7. QUAIS SÃO OS DIREITOS DOS TITULARES DE DADOS?
          </PolicySubtitle>
          <p>
            7.1. Você sempre poderá optar por não divulgar seus Dados Pessoais
            para nós. Mas tenha em mente que alguns desses Dados Pessoais podem
            ser necessários para se registrar em nossa Plataforma e ter acesso
            aos nossos Serviços.
          </p>
          <p>
            7.1.2. Independente disso, você sempre poderá solicitar o exercício
            dos direitos relativos à privacidade e à proteção dos seus Dados
            Pessoais e a Consorciei receberá, tratará e responderá tais
            solicitações dentro dos prazos legais. Quando não for possível
            realizar a solicitação, nós informaremos a você as razões
            impeditivas.
          </p>
          <p>
            7.2. Além de nos preocuparmos com a segurança desses dados, também
            nos preocupamos com que você tenha acesso e conhecimento de todos os
            seus direitos relativos a Dados Pessoais:
            <br /> <br />
            <li>
              Acesso aos Dados Pessoais: você pode acessar os seus Dados
              Pessoais, inclusive solicitando cópia dos dados tratados.
            </li>
            <li>
              Confirmação da existência de tratamento: você pode confirmar se
              nós estamos tratando os seus Dados Pessoais.
            </li>
            <li>
              Correção de dados incompletos, inexatos ou desatualizados: você
              pode solicitar alteração ou correção dos seus Dados Pessoais que
              estejam incorretos.
            </li>
            <li>
              Portabilidade: você pode solicitar a portabilidade dos seus dados
              para outro fornecedor de serviços, quando aplicável.
            </li>
            <li>
              Eliminação dos Dados Pessoais: Você pode solicitar a exclusão de
              seus Dados Pessoais que tratamos quando estes tiverem sido
              coletados e tratados com base em seu consentimento, por
              solicitação pelos canais de atendimento indicados nesta Política.
            </li>
            <li>
              Informação sobre compartilhamento: Você pode solicitar que nós
              informemos se compartilhamos seus dados com outros e, se sim, como
              quem, nos termos desta Política.
            </li>
            <li>
              Revogação do consentimento: você pode, a qualquer momento e a seu
              critério, revogar o consentimento anteriormente fornecido para
              tratamento de Dados Pessoais, permanecendo os tratamentos
              realizados com base nele, até tal momento, válidos.
            </li>
            <li>
              Anonimização, bloqueio ou eliminação de dados: Você pode solicitar
              que a Consorciei proceda à anonimização, ao bloqueio ou
              anonimização de Dados Pessoais que sejam excessivos.
            </li>
            <li>
              Oposição ao Tratamento de dados: você pode se opor ao tratamento
              de Dados Pessoais que seja fundado em uma base legal que não o
              consentimento.
            </li>
            <li>
              Revisão de decisões tomadas exclusivamente com base em Tratamento
              automatizado de dados. Caso a Consorciei tome qualquer decisão
              baseada exclusivamente em tratamento de Dados Pessoais
              automatizados, Você pode solicitar que essas decisões sejam
              revistas.
            </li>
            <li>
              Informação sobre a possibilidade de não consentir: você recebe por
              meio da presente Política e pode solicitar, pelos canais de
              atendimento, informações sobre a possibilidade de não consentir
              com o tratamento de Dados Pessoais e suas potenciais
              consequências.
            </li>
            <li>
              Revogação do consentimento: você pode, a qualquer momento e a seu
              critério, revogar o consentimento anteriormente fornecido para
              tratamento de Dados Pessoais, permanecendo os tratamentos
              realizados com base nele, até tal momento, válidos.
            </li>
          </p>
          <p>
            7.3. Talvez seja necessário solicitar informações específicas suas
            para nos ajudar a confirmar sua identidade e garantir o exercício de
            seus direitos sobre os seus Dados Pessoais. Esta é uma medida de
            segurança para garantir que os Dados Pessoais não sejam divulgados a
            qualquer pessoa que não tenha direito de recebê-los. Podemos também
            contatar você para obter mais informações em relação à sua
            solicitação, a fim de acelerar nossa resposta.
          </p>
          <p>
            7.4. Responderemos a todas as solicitações legítimas dentro dos
            prazos legais. Ocasionalmente, pode levar mais de 7 (sete) dias se
            sua solicitação for particularmente complexa ou se você tiver feito
            várias solicitações. Neste caso, iremos notificá-lo e mantê-lo
            atualizado sobre o andamento da sua solicitação.
          </p>
          <p>
            7.4.1 Caso Você tenha alguma dúvida sobre essas questões e sobre
            como você pode exercer Seus direitos, fique à vontade para entrar em
            contato com nosso Comitê de Dados Pessoais (líder João Ferraz):
            dpo@consorciei.com.br
          </p>
          <p>
            7.5. Consequências do cumprimento com solicitação de exclusão de
            dados. É importante ressaltarmos que se excluirmos seus Dados
            Pessoais em atendimento a um pedido feito por você, as nossas
            Plataformas poderão deixar de funcionar para os fins propostos e
            podemos ficar impedidos de prestar os Serviços.
          </p>
          <p>
            7.5.1. Eventual solicitação de exclusão de Dados Pessoais poderá
            implicar na impossibilidade de acesso a determinadas áreas dentro da
            Plataforma, bem como visualização de determinados conteúdos ou mesmo
            o encerramento dos Serviços. O seu pedido de exclusão de dados não
            implica que nós não poderemos utilizar dados de forma distinta, sem
            qualquer identificação pessoal, não individualizada e anonimizada.
            Finalmente, se não formos atender seu pedido, nós explicaremos os
            motivos da recusa de exclusão dos seus Dados Pessoais.
          </p>
          <PolicySubtitle>
            8. POR QUANTO TEMPO A CONSORCIEI RETERÁ OS DADOS?
          </PolicySubtitle>
          <p>
            8.1. Nós manteremos seus Dados Pessoais somente pelo tempo que for
            necessário para cumprir com as finalidades para as quais os
            coletamos, observando os limites legais aplicáveis. Para determinar
            o período de retenção adequado para os Dados Pessoais, consideramos
            a quantidade, a natureza e a sensibilidade, o risco potencial de
            danos decorrentes do uso não autorizado ou da divulgação, a
            finalidade de processamento e se podemos alcançar tais propósitos
            por meio de outros meios e os requisitos legais aplicáveis.
          </p>
          <p>
            8.2. Poderemos guardar os Dados Pessoais de certos usuários por um
            período superior ao de guarda legal, em cumprimento de eventuais
            ordens de autoridade públicas, para nos defendermos em processos
            judiciais e/ou administrativos e em casos nos quais os Dados
            Pessoais tenham sido devidamente anonimizados. Se Você registrou uma
            conta na Consorciei, as informações da sua conta, incluindo seus
            Dados Pessoais vinculados a esta, serão mantidas enquanto você
            mantiver essa conta ativa.
          </p>
          <PolicySubtitle>
            9. COMO FUNCIONA A SEGURANÇA DA INFORMAÇÃO NA CONSORCIEI
          </PolicySubtitle>
          <p>
            9.1. A Consorciei fará todo o possível para manter os Dados Pessoais
            seguros, incluindo a adoção de medidas de segurança e proteção
            compatíveis com os dados coletados. Para tanto adotamos diversas
            medidas, como a permissão para que seus Dados Pessoais sejam
            acessados somente por colaboradores ou parceiros devidamente
            autorizados e cujas atribuições estejam estritamente vinculadas aos
            Serviços, respeitando os princípios de finalidade, adequação,
            necessidade e aqueles outros inerentes ao tratamento de Dados
            Pessoais, além do compromisso de confidencialidade e preservação da
            privacidade nos termos desta Política e da LGPD.
          </p>
          <p>
            9.2. Sua conta é protegida por uma senha para sua privacidade e
            segurança. Se Você acessar sua conta por meio de um site ou serviço
            de terceiros, poderá ter proteções de login adicionais ou diferentes
            por meio desse site ou serviço.
          </p>
          <p>
            9.3. Você deve impedir e evitar o acesso não autorizado de terceiros
            à sua conta e aos Dados Pessoais, selecionando e protegendo sua
            senha, limitando o acesso ao seu computador ou dispositivo e
            navegador a outras pessoas e/ou fazendo logout após ter concluído o
            acesso à sua conta.
          </p>
          <p>
            9.4. Com a finalidade de garantir a sua privacidade e a proteção dos
            seus Dados Pessoais, desenvolvemos nossas Plataformas e prestamos
            nossos Serviços pautados no conceito de privacy by design, ou seja,
            de forma que você possa gerenciar as suas informações diretamente.
            Aliado a esse conceito, adotamos práticas de criptografia e
            autenticação.
          </p>
          <p>
            9.5. Nós nos esforçamos para proteger a privacidade de Sua conta e
            de outros Dados Pessoais que mantemos em nossos registros. Mas,
            infelizmente, não podemos garantir total segurança. Entrada ou uso
            não autorizado de conta, falha de hardware ou software e outros
            fatores podem comprometer a segurança dos seus Dados Pessoais a
            qualquer momento, por isso, nos ajude a manter um ambiente seguro
            para todos.
          </p>
          <p>
            {' '}
            9.6. Além de adotar boas práticas de segurança em relação à sua
            conta e aos seus Dados Pessoais, caso você identifique ou tome
            conhecimento de algo que comprometa a segurança da sua privacidade,
            por favor entre em contato conosco imediatamente. Apesar dos nossos
            melhores esforços, não podemos garantir que tais medidas de
            segurança sejam isentas de erros ou que não estejam sujeitas à
            interferência de terceiros (hackers, entre outros). Por sua
            natureza, qualquer medida de segurança pode falhar e qualquer dado
            pode se tornar público. A Consorciei NÃO SERÁ RESPONSÁVEL POR ESSE
            TIPO DE VAZAMENTO DE DADOS.
          </p>
          <PolicySubtitle>
            10. COMO ESCLARECER OUTRAS DÚVIDAS? FALE COM A CONSORCIEI
          </PolicySubtitle>
          <p>
            Se você tiver alguma dúvida, solicitação ou preocupação a respeito
            desta Política, sobre nossas práticas tratamento de Dados Pessoais
            ou, ainda, sobre uma possível violação ou quebra de sigilo de Dados
            Pessoais ou de privacidade, Você pode entrar em contato conosco
            pelos seguintes dados de contato:
          </p>
          <p>
            Comitê de Dados Pessoais (líder João Ferraz) <br />
            E-mail: dpo@consorciei.com.br <br />
            Endereço: Av. Brigadeiro Faria Lima, 1461, 4º andar, Jardim
            Paulistano, São Paulo-SP, CEP 01451-002
          </p>
          <p>
            Quais leis aplicáveis à esta Política? Os termos desta Política são
            regidos e deverão ser interpretados de acordo com as Leis da
            República Federativa do Brasil.
          </p>
          <p>
            Quem são os responsáveis pelos links na Plataforma que levam à sites
            de terceiros? Nossa Plataforma pode conter links para outros sites
            que não são operados por nós. Se Você clicar em um link de
            terceiros, você será direcionado para o site de terceiros.
            Recomendamos que reveja a política de privacidade de todos os sites
            que visita, uma vez que não temos controle e não assumimos qualquer
            responsabilidade pelo conteúdo, políticas de privacidade ou práticas
            de quaisquer sites ou serviços de terceiros. Eu ainda tenho algumas
            dúvidas… em caso de dúvida ou requerimento do exercício de algum dos
            seus direitos sobre os seus Dados Pessoais, você poderá entre em
            contato conosco por meio dos canais listados acima.
          </p>
          <PolicySubtitle>
            11. MUDANÇAS NA POLÍTICA DE PRIVACIDADE
          </PolicySubtitle>
          <p>
            Como estamos sempre buscando melhorar, esta nossa Política pode
            passar por atualizações. Assim, recomendamos que Você visite
            periodicamente nossa Plataforma para que Você tenha conhecimento
            sobre as modificações. Caso sejam feitas alterações relevantes e que
            exijam um novo consentimento seu, publicaremos uma atualização da
            nova Política e solicitaremos a Você um novo consentimento. Você
            sempre será notificado por e-mail quando fizermos uma atualização
            relevante desta Política.
          </p>
          <br />
          <i>Versão publicada em 15 de março de 2024.</i>
        </ContentStyled>

        <ButtonWrapperStyled>
          <Button
            color="primary"
            variant="goFoward"
            fullWidth
            onClick={props.closeModal}
          >
            Fechar
          </Button>
        </ButtonWrapperStyled>
      </WrapperStyled>
    </Modal>
  );
}
